import { WalletProviderE } from '@tacans/shared-marketplace-layer';
import React from 'react';
import { useBlockChainsById } from 'src/features/common/wallet/hooks/wallet.hooks';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { ISvgIcon } from 'src/ui/common/atoms/svg-icon/svg-icon.types';
import { ICONS } from './nft-blockchain-icon.constants';

interface Props {
    blockchainId: number;
    className?: string;
    height?: number;
    width?: number;
}
export const NftBlockchainIcon = ({ blockchainId, className, width, height }: Props) => {
    const blockChainsById = useBlockChainsById();

    const chain = blockChainsById[blockchainId];

    const iconConfig: ISvgIcon = ICONS[chain?.name as WalletProviderE];

    if (!iconConfig) {
        return null;
    }

    return (
        // @ts-ignore
        <SvgIcon
            className={className}
            icon={iconConfig.icon}
            variant={iconConfig.variant}
            width={width}
            height={height}
        />
    );
};
